import { render, staticRenderFns } from "./role-badge.vue?vue&type=template&id=c21e63f8"
import script from "./role-badge.ts?vue&type=script&lang=js&external"
export * from "./role-badge.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports